import { Vue, i18n } from 'Common/vue';

import "../../layouts/default"

import '../../components/slider'
import '../../components/shorten'
import '../../components/more-items'
import '../../components/favorite-trigger';
import { scrollTo } from '../../common/anchor';
import '../../common/lightgallery';

import './catalog-jquery'
import './filter-slider-age';

const catFilterElem = document.querySelector('#categoriesFilter');
const filterElem = document.getElementById("filter");

if (catFilterElem) {
    const productsCategories = catFilterElem.dataset.categories;
    const selectedCategoryId = catFilterElem.dataset.selected;

    new Vue({
        el: '#categoriesFilter',
        components: {
            CategoriesFilter: () => import('VueComponents/CategoriesFilter.vue')
        },
        template: `<CategoriesFilter :select-category-id="${selectedCategoryId || null}" :products-categories="${productsCategories}"></CategoriesFilter>`
    });
}

if (filterElem !== null) {
    filterElem.addEventListener("category.changed", function (e) {
        const categoryId = e.detail.category_id;
        const filterCategoryIdInput = document.getElementById('filterCategoryId');

        if (filterCategoryIdInput) {
            filterCategoryIdInput.value = categoryId;
        }
        Filter.submit();
    });
}

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll('.pager__list .c-btn')) {
        if (pagerButton.classList.contains('is-active')) continue

        pagerButton.addEventListener('click', (event) => {
            scrollTo(document.querySelector('.l-catalog-products') || document.querySelector('.listing'), 0)
        })
    }
}

attachPaginatorEvents()

rEvent.on('Listing.fetchedData', () => {
    attachPaginatorEvents()
})